import { PlayerProperty, Restore, Save } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from 'State/Player/IPlayerState';
import { dateToString, restoreDate } from '../../ParseHelper';
import { FilteredKeys } from 'Utility/Types';

export default class DateProperty<
    TPlayerStateKey extends FilteredKeys<IPlayerState, Date>,
    TPlayerDataKey extends FilteredKeys<IPlayerData, string>
> implements PlayerProperty<TPlayerStateKey, TPlayerDataKey> {
    private readonly playerStateKey: TPlayerStateKey;
    private readonly playerDataKey: TPlayerDataKey;
    private readonly defaultGetter: () => Date;

    /**
     *
     * @param playerStateKey
     * @param playerDataKey
     * @param defaultGetter If true and no existing date is found then this function is used to retrieve a default value.
     */
    constructor(playerStateKey: TPlayerStateKey, playerDataKey: TPlayerDataKey, defaultGetter?: () => Date) {
        this.playerStateKey = playerStateKey;
        this.playerDataKey = playerDataKey;
        this.defaultGetter = defaultGetter;
    }

    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        return playerEndpointData[this.playerDataKey] !== this.save(playerStateData)[this.playerDataKey];
    }

    public restore(playerEndpointData: IPlayerData): Restore<TPlayerStateKey> {
        return restoreDate(playerEndpointData[this.playerDataKey]) ?? this.defaultGetter?.call(this);
    }

    public save(playerStateData: IPlayerState): Save<TPlayerDataKey> {
        return {
            [this.playerDataKey]: dateToString(playerStateData[this.playerStateKey]),
        } as Pick<IPlayerData, TPlayerDataKey>;
    }
}
